import React from 'react';
import { Box, Typography } from '@mui/material';

// Import zodiac images
import ariesImage from '../assets/images/aries.png';
import taurusImage from '../assets/images/taurus.png';
import geminiImage from '../assets/images/gemini.png';
import cancerImage from '../assets/images/cancer.png';
import leoImage from '../assets/images/leo.png';
import virgoImage from '../assets/images/virgo.png';
import libraImage from '../assets/images/libra.png';
import scorpioImage from '../assets/images/scorpio.png';
import sagittariusImage from '../assets/images/sagittarius.png';
import capricornImage from '../assets/images/capricorn.png';
import aquariusImage from '../assets/images/aquarius.png';
import piscesImage from '../assets/images/pisces.png';

// Create a mapping of zodiac signs to their images
const zodiacImages: Record<string, string> = {
    'aries': ariesImage,
    'taurus': taurusImage,
    'gemini': geminiImage,
    'cancer': cancerImage,
    'leo': leoImage,
    'virgo': virgoImage,
    'libra': libraImage,
    'scorpio': scorpioImage,
    'sagittarius': sagittariusImage,
    'capricorn': capricornImage,
    'aquarius': aquariusImage,
    'pisces': piscesImage
};

interface ZodiacDisplayProps {
    zodiacSign: string;
    zodiacName: string;
    imageSize?: number; // size in rem
    showText?: boolean;
    textVariant?: 'subtitle1' | 'subtitle2' | 'body1' | 'body2' | 'h6';
    textPrefix?: string;
    textSuffix?: string;
    direction?: 'row' | 'column';
    gap?: number; // gap in rem
}

const ZodiacDisplay: React.FC<ZodiacDisplayProps> = ({
    zodiacSign,
    zodiacName,
    imageSize = 16, // 16rem = 256px at default font size
    showText = true,
    textVariant = 'subtitle1',
    textPrefix = '',
    textSuffix = '',
    direction = 'row',
    gap = 0.5 // 0.5rem = 8px at default font size
}) => {
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: `${gap}rem`,
            flexDirection: direction
        }}>
            {showText && (
                <Typography variant={textVariant}>
                    {textPrefix && <strong>{textPrefix}</strong>}
                    {zodiacName}
                    {textSuffix}
                </Typography>
            )}
            {zodiacSign && zodiacImages[zodiacSign] && (
                <Box
                    component="img"
                    src={zodiacImages[zodiacSign]}
                    alt={zodiacName}
                    sx={{
                        width: `${imageSize}rem`,
                        height: `${imageSize}rem`,
                        objectFit: 'contain'
                    }}
                />
            )}
        </Box>
    );
};

export default ZodiacDisplay; 